<template>
  <div class="winners" :class="{'with-game': game}">
    <div class="block-title">
      <div class="title">Winners Live <button @click="getWinners" style="display: none">+</button></div>
      <div class="led"></div>
    </div>
    <div class="table-wrapper">

      <table class="table">
        <transition-group v-if="showData.length" mode="out-in" name="list" tag="tbody" class="tbody">

          <tr
              class="tr"
              v-for="(row, index) in showData"
              :key="row.id"
          >
            <td
                class="td"
                :class="'td-'+data.headers[idx]"
                v-for="(item, name, idx) in row"
                :key="idx + '_item_td'"
                v-if="data.headers[idx]"
            >
              <template v-if="data.headers[idx] === 'image'">
                <img :src="gamesImages[row['game']] ?? './images/no-image.png'" :alt="row['game']" @error="imageUrlAlt">
              </template>
              <template v-else-if="data.headers[idx] === 'name'">
                <div>
                  <span v-if="game">Player #{{ row['id'] }}</span>
                  <span v-else>{{ row['game'] }}</span>
                  <span>{{ $moment(row['date']).fromNow() }}</span>
                </div>
              </template>
              <template v-else-if="data.headers[idx] === 'win'">
                <div>
                  <span>€{{ (Math.round(row['win'] * 100) / 100).toFixed(2) }}</span>
                </div>
              </template>
              <template v-else-if="data.headers[idx] === 'bet'">
                <div>
                  <span class="win-in-bet">€{{ (Math.round(row['win'] * 100) / 100).toFixed(2) }}</span>
                  <span>{{ (Math.round(row['bet'] * 100) / 100).toFixed(2) }} x bet</span>
                </div>
              </template>
              <template v-else-if="data.headers[idx] === 'actions'">
                <a :href="row['replayURL']" target="_blank">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.00033 6C7.46989 6 6.96118 6.21071 6.58611 6.58579C6.21104 6.96086 6.00033 7.46957 6.00033 8C6.00033 8.53043 6.21104 9.03914 6.58611 9.41421C6.96118 9.78929 7.46989 10 8.00033 10C8.53076 10 9.03947 9.78929 9.41454 9.41421C9.78961 9.03914 10.0003 8.53043 10.0003 8C10.0003 7.46957 9.78961 6.96086 9.41454 6.58579C9.03947 6.21071 8.53076 6 8.00033 6ZM8.00033 11.3333C7.11627 11.3333 6.26842 10.9821 5.6433 10.357C5.01818 9.7319 4.66699 8.88406 4.66699 8C4.66699 7.11595 5.01818 6.2681 5.6433 5.64298C6.26842 5.01786 7.11627 4.66667 8.00033 4.66667C8.88438 4.66667 9.73223 5.01786 10.3573 5.64298C10.9825 6.2681 11.3337 7.11595 11.3337 8C11.3337 8.88406 10.9825 9.7319 10.3573 10.357C9.73223 10.9821 8.88438 11.3333 8.00033 11.3333ZM8.00033 3C4.66699 3 1.82033 5.07333 0.666992 8C1.82033 10.9267 4.66699 13 8.00033 13C11.3337 13 14.1803 10.9267 15.3337 8C14.1803 5.07333 11.3337 3 8.00033 3Z" fill="white"/>
                  </svg>
                </a>
              </template>
<!--              <slot :name="data.headers[idx]" :item="row">-->
<!--                {{ row[idx] }}-->
<!--              </slot>-->
            </td>
          </tr>

        </transition-group>
        <tbody class="tbody" v-else>
          <tr class="tr" style="justify-content: center;">
            <td class="td" :colspan="data.headers.length" style="width: 100%;">
              No data yet.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'winners-live-block',
  props: {
    gamesImages: {},
    game: null,
  },
  data() {
    return {
      data: {
        headers: [
          "image",
          "name",
          "bet",
          "actions"
        ],
        content: [

        ]
      },
      showData: [],
      firstLoad: true,
    }
  },
  methods: {
    getWinners: async function() {
      await this.$request.get('/true-world/winners-live' + (this.game ? '?game=' + this.game : ''), null, response => {
        if(this.firstLoad) {
          this.data.content = response
          if(response) {
            this.showData = this.data.content.slice(this.data.content.length-6, this.data.content.length)
          } else this.showData = [];
          this.firstLoad = false;
        } else {
          let newElems = [];

          response.forEach((item) => {
            if (this.data.content.map(e => e.id).indexOf(item.id) === -1) {
              newElems.push(item)
            }
          })

          newElems.forEach((newItem) => {
            this.data.content.unshift(newItem);
          })

          const it = newElems[Symbol.iterator](); // convenient for yeilding values
          const int = setInterval(() => { // time interval
            const next = it.next(); // next value
            if (!next.done) { // done = true when the end of array reached
              this.showData.unshift(next.value)
              this.showData = this.showData.slice(0, 6)
            } else {
              clearInterval(int);
            }
          }, 3000)
        }
      }, error => {
        console.log(error)
      })
    },
    appendWinner: function() {
      if(this.data.content.length) {
        const it = this.data.content.slice(0, this.data.content.length-6).reverse()[Symbol.iterator](); // convenient for yeilding values
        const int = setInterval(() => { // time interval
          const next = it.next(); // next value
          if (!next.done) { // done = true when the end of array reached
            this.showData.unshift(next.value)
            this.showData = this.showData.slice(0, 6)
          } else {
            clearInterval(int);
          }
        }, 3000) // interval duration, 1s
      }
    },
    imageUrlAlt: (event) => {
      event.target.src = require("./images/no-image.png");
    }
  },
  async mounted() {
    if(this.game) {
      this.data.headers = [
        "image",
        "name",
        "bet",
        "win",
        "actions"
      ]
    }
    this.$moment.updateLocale('en', {
      relativeTime : {
        future: "in %s",
        past:   "%s ago",
        s  : 'a few seconds',
        ss : '%d seconds',
        m:  "a minute",
        mm: "%d minutes",
        h:  "1 hour", //this is the setting that you need to change
        hh: "%d hours",
        d:  "a day",
        dd: "%d days",
        w:  "a week",
        ww: "%d weeks",
        M:  "1 month", //change this for month
        MM: "%d months",
        y:  "a year",
        yy: "%d years"
      }
    });

    await this.getWinners();
    this.appendWinner();
    setInterval(() => { this.getWinners() }, 16000);
  }
}
</script>

<style lang="less">
.winners {
  width: 300px;
  overflow: hidden;
  max-height: 396px;

  > .block-title {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 13px;
    gap: 10px;
    position: relative;

    .title {
      color: #fff;
      font-size: 22px;
      font-weight: 500;
      line-height: 33px;
      flex-grow: 0;
    }
    .led {
      position: relative;
      right: auto;
      top: auto;
      margin-left: 6px;
      width: 11px;
      height: 11px;
      border-radius: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      animation: led 1s ease-in infinite;
      background: transparent;

      @keyframes led {
        0% {
          outline: 6px solid rgba(119, 218, 41, 0.2);
        }
        50% {
          outline: 1px solid rgba(119, 218, 41, 0.2);
        }
        100% {
          outline: 6px solid rgba(119, 218, 41, 0.2);
        }
      }
    }
    .led:before {
      content: '';
      position: relative;
      display: flex;
      width: 11px;
      height: 11px;
      background: rgba(119, 218, 41, 1);
      border-radius: 100%;
    }
  }
  > .table-wrapper {
    margin: 0 auto;
    position: relative;
    z-index: 2;

    > table {
      display: flex;
      border-radius: 15px;
      overflow: hidden;
      width: 100%;

      > tbody {
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 5px;

        > tr {
          width: 100%;
          display: flex;
          flex-direction: row;
          background: rgba(201, 216, 255, 0.1);
          backdrop-filter: blur(55px);
          border-radius: 16px;

          > td {
            display: flex;
            align-items: center;
            justify-content: center;
            color: rgba(255, 255, 255, 1);
            font-size: 15px;
            font-weight: 500;
            line-height: 23px;
            text-align: left;
            height: 52px;

            &.td-image {
              padding: 0 7px;
              > img {
                border-radius: 7.69px;
                width: 40px;
                height: 40px;
              }
            }
            &.td-name {
              flex: 1;
              justify-content: flex-start;
              > div {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;

                > span:first-child {
                  font-size: 12px;
                  font-weight: 500;
                  line-height: 18px;
                  display: block;
                  text-wrap: nowrap;
                  max-width: 100px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                > span:last-child {
                  font-size: 10px;
                  font-weight: 400;
                  line-height: 11px;
                  color: #FFFFFF99;
                }
              }
            }

            &.td-win {
              justify-content: center;
              > div {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;

                > span {
                  font-size: 13px;
                  font-weight: 700;
                  line-height: 19.5px;
                }
              }
            }

            &.td-bet {
              flex: 1;
              text-align: right;
              justify-content: flex-end;
              //width: 80px;
              > div {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-end;

                > span:first-child {
                  font-size: 13px;
                  font-weight: 700;
                  line-height: 19.5px;
                }
                > span:last-child {
                  font-size: 11px;
                  font-weight: 500;
                  line-height: 16.5px;
                  color: #FFFFFF99;
                }
              }
            }

            &.td-actions {
              width: 48px;
              padding-left: 10px !important;
              padding-right: 10px !important;

              > a {
                display: flex;
                width: 24px;
                height: 24px;
                background: rgba(201, 216, 255, 0.12);
                justify-content: center;
                align-items: center;
                border-radius: 6px;
                &:hover {
                  background: rgba(201, 216, 255, 0.22);
                }
              }
            }
          }
        }
      }
    }
  }

  &.with-game {
    .win-in-bet {
      display: none;
    }
    > .table-wrapper > table > tbody > tr > td.td-name > div > span:first-child {
      max-width: 200px;
    }
  }
}
@media screen and (max-width: 1439px) {
  .winners {
    width: 214px;
    max-height: 410px;
    .led {
      width: 20px;
      height: 20px;
      &:before {
        width: 10px;
        height: 10px;
      }
    }
    > .table-wrapper > table > tbody {
      gap: 6px;
    }
    > .table-wrapper > table > tbody > tr {
      flex-wrap: wrap;
      > td.td-name {
        min-width: 210px;
        order: 4;
        padding-left: 10px;
        height: auto;
        padding-bottom: 4px;
        > div {
          > span:first-child {
            max-width: 140px;
          }
        }
      }
      > td.td-bet {
        min-width: 62px;
        flex: 1;
      }
      > td.td-actions {
        width: auto;
      }
    }
    &.with-game {
      > .table-wrapper > table > tbody > tr > td.td-name > div > span:first-child {
        max-width: 180px;
      }
      > .table-wrapper > table > tbody > tr > td.td-win {
        display: none;
      }
      .win-in-bet {
        display: block;
      }
    }
  }
}
@media screen and (max-width: 1023px) {
  .winners {
    width: 100%;
    height: 314px;
    padding: 0;
    > .block-title {
      margin-bottom: 10px;
      .title {
        font-size: 18px;
        line-height: 27px;
      }
      .led {
        width: 10px;
        height: 10px;
        &:before {
          width: 10px;
          height: 10px;
        }
      }
    }
    > .table-wrapper > table > tbody > tr {
      border-radius: 12px;
      > td {
        height: 50px;
        &.td-image {
          img {
            width: 36px;
            height: 36px;
            border-radius: 8px;
          }
        }
        &.td-name {
          order: unset;
          padding-left: 2px;
          > div {
            > span:first-child {
              font-size: 11px;
              line-height: 16.5px;
              max-width: max-content;
            }
          }
        }
        &.td-bet {
          flex-grow: 0;
          min-width: 62px;
          > div {
            > span:first-child {
              font-size: 12px;
              line-height: 18px;
            }
            > span:last-child {
              font-size: 11px;
              line-height: 16.5px;
            }
          }
        }
        &.td-actions {
          width: auto;
        }
      }
    }
    &.with-game {
      > .table-wrapper > table > tbody > tr > td.td-name > div > span:first-child {
        max-width: 110px;
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .winners {
    width: 100%;
    height: 310px;
    padding: 0;
    border-radius: 0px;
    margin-bottom: 0;
    > .block-title {
      margin-bottom: 10px;
      flex-wrap: nowrap;
      .title {
        font-size: 16px;
        line-height: 24px;
      }
      .led {
        width: 13px;
        height: 13px;
        &:before {
          width: 9px;
          height: 9px;
        }
      }
    }
    > .table-wrapper > table > tbody > tr {
      border-radius: 12px;
      flex-wrap: nowrap;
      > td {
        height: 50px;
        &.td-image {
          img {
            width: 36px;
            height: 36px;
            border-radius: 6px;
          }
        }
        &.td-name {
          width: 100%;
          order: unset;
          padding-left: 2px;
          min-width: 88px;
          max-width: 88px;
          > div {
            > span:first-child {
              font-size: 11px;
              line-height: 16.5px;
              max-width: 100px;
            }
          }
        }
        &.td-bet {
          flex: 1;
          flex-grow: 1;
          min-width: 62px;
          > div {
            > span:first-child, > span:last-child {
              font-size: 11px;
              line-height: 16.5px;
            }
          }
        }
        &.td-actions {
          width: auto;
        }
      }
    }
    &.with-game {
      > .table-wrapper > table > tbody > tr > td.td-name > div > span:first-child {
        max-width: 100px;
      }
    }
  }
}
</style>
